// useSocialMedia.js
import { useDispatch } from "react-redux";
import { logout } from "../features/auth/authSlice";
import { loginwithfacebook, loginwithgoogle } from "../thunks/authThunk";


console.log("dans sociel media");
export default function useSocialMedia() {
  const dispatch = useDispatch();

  const handleGoogleLogin = ({ handleCloseForm }) => {
    dispatch(loginwithgoogle({ handleCloseForm }));
  };

  const handleFacebookLogin = ({ handleCloseForm }) => {
    dispatch(loginwithfacebook({ handleCloseForm }));
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return { handleGoogleLogin, handleFacebookLogin, handleLogout };
}
